import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router';

import { forceHttpsUri } from 'Helpers/Uri';

export default class AlbumHeader extends React.Component {
    static propTypes = {
        album: PropTypes.shape({
            name: PropTypes.string,
            coverPhoto: PropTypes.shape({
                w1280: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };
    static defaultProps = {};

    render() {
        const { album } = this.props;

        return (
            <header className="component-album-header scroll-section-fixed" style={{ backgroundImage: `url(${forceHttpsUri(album.coverPhoto.w1280)})` }}>
                <div className="mask"></div>
                <div className="headline-container">
                    <h1 className="headline">{album.name}</h1>
                </div>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/album/Header/index.js